//  Copyright (c) 2020 Comsearch, Inc., All rights reserved

export const CREATE_NEW_PROJECT = 'CREATE_NEW_PROJECT'
